import { Component } from 'react';
import { translateKey } from '../../../translate';
import { Header, LinkButton } from '../../elements/common';
import { FullWidthTemplate } from '../../templates/FullWidthTemplate';
import { ServiceGraderPoolList } from './components/List/ServiceGraderPoolList';

interface IServiceGraderPoolProps {
    serviceId: string;
}

export class ServiceGraderPool extends Component<IServiceGraderPoolProps> {
    public render() {
        return (
            <FullWidthTemplate>
                <Header
                    actionButtons={[
                        <LinkButton
                            icon="add"
                            key="add"
                            right
                            to={`/serviceGraderPools/add?serviceId=${this.props.serviceId}`}
                        >
                            {translateKey('common.add')}
                        </LinkButton>,
                    ]}
                    content={translateKey('serviceGraderPool.serviceGraderPool')}
                />
                <ServiceGraderPoolList serviceId={this.props.serviceId} />
            </FullWidthTemplate>
        );
    }
}
